import AbstractCanopyStyle from "./AbstractCanopyStyle";

export default class SmoothCanopyStyle extends AbstractCanopyStyle {
    display(g, opacity) {
        g.ellipse(this.ellipse.currentX, this.ellipse.currentY, this.ellipse.currentSize);
    }

    getMiniView(size) {
        return [size, size];
    }
}
